// GENERATED by scripts/build-icons.mjs from icons/terminal.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Terminal = createIcon('terminal', [
  ['path', { d: "M12 19h8" }],
  ['path', { d: "m4 17 6-6-6-6" }],
])
